import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Settings2 } from "lucide-react";

export const ShopSettingsCard = ({ s, onSaved }) => {
  const [f, setF] = useState(s);
  useEffect(() => { setF(s); }, [s]);
  const save = async () => {
    try { await api.put("/shop/settings", f); toast.success("Tracking settings saved"); onSaved(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  const example = f.mode === "cuelinks"
    ? `https://linksredirect.com/?cid=${f.cuelinks_cid || "YOUR_CID"}&source=linkkit&url=https%3A%2F%2Fstore.com%2Fitem`
    : `https://store.com/item?${f.aff_param || "affid"}=${f.aff_id || "YOUR_ID"}`;
  return (
    <Card className="p-4 bg-card/40 border-gold/25" data-testid="shop-settings-card">
      <p className="eyebrow text-gold flex items-center gap-1.5 mb-2"><Settings2 className="w-4 h-4" /> Affiliate tracking (one ID for every store)</p>
      {(() => {
        const on = s.mode === "cuelinks" ? !!s.cuelinks_cid : !!s.aff_id;
        return <p data-testid="shop-tracking-status" className={`mb-2 rounded-md px-3 py-1.5 text-xs font-semibold ${on ? "bg-emerald-500/15 text-emerald-200" : "bg-amber-500/15 text-amber-200"}`}>
          {on ? `Tracking active — every Buy Now goes through your ${s.mode === "cuelinks" ? "Cuelinks" : "affiliate"} link` : "Waiting for your ID — Buy Now opens the store link untracked until you add it"}</p>;
      })()}
      <div className="flex gap-2 mb-2">
        {[["param", "Add ?affid= to link"], ["cuelinks", "Cuelinks redirect"]].map(([k, l]) => (
          <button key={k} onClick={() => setF({ ...f, mode: k })} data-testid={`shop-mode-${k}`} className={`flex-1 h-9 rounded-full text-xs font-semibold border ${f.mode === k ? "bg-gold text-[#0a2e22] border-gold" : "border-gold/30 text-white/80"}`}>{l}</button>
        ))}
      </div>
      {f.mode === "cuelinks" ? (
        <Input value={f.cuelinks_cid || ""} onChange={(e) => setF({ ...f, cuelinks_cid: e.target.value.replace(/\D/g, "") })} placeholder="Numbers only, e.g. 331878" data-testid="shop-cuelinks-cid-input" className="bg-card/60" />
      ) : (
        <div className="grid grid-cols-3 gap-2">
          <Input value={f.aff_param || ""} onChange={(e) => setF({ ...f, aff_param: e.target.value.trim() })} placeholder="affid" data-testid="affiliate-param-input" className="bg-card/60" />
          <Input value={f.aff_id || ""} onChange={(e) => setF({ ...f, aff_id: e.target.value.trim() })} placeholder="Your affiliate ID" data-testid="affiliate-id-setting-input" className="bg-card/60 col-span-2" />
        </div>
      )}
      <p className="text-[10px] text-muted-foreground mt-2 break-all" data-testid="shop-link-example">Buy Now goes to: {example}</p>
      <Button onClick={save} data-testid="shop-settings-save" className="mt-2 bg-gold text-[#0a2e22] hover:bg-gold/90">Save tracking</Button>
    </Card>
  );
};
